import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { LoginSuccessAction, LogLogoutsuccessAction } from '../features/auth/auth.actions';
import { environment } from '../../environments/environment';
import { selectAuthToken } from '../features/auth/auth.selectors';
import { take, map } from 'rxjs/operators';
import { getCookie } from './cookies.service';
import { HttpParams } from '@angular/common/http';
import { isNullOrUndefined } from 'util';
import { AuthService } from '../features/auth/auth.service';
import { getSessionToken } from './session.service';

@Injectable()
export class LoginGuard implements CanActivate, CanActivateChild {
  public constructor(private readonly store: Store<AppState>, private readonly router: Router,
    private readonly _authService: AuthService
  ) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // const cookieToken = getCookie('auth_token');
    const cookieToken = getSessionToken();

    if (cookieToken) {
      this._authService.fullyAuthenticated$.pipe(
        map(fullyAuthenticated => {
          if (fullyAuthenticated) {
            this.store.dispatch(new LoginSuccessAction({ token: `cookieToken`, vds: `sessionId` }));
            return true;
          }
          return false;
        }),
      );
    } else if (state.url.indexOf('?reason=USER_LOGGED_OUT') > 0) {
      this.store.dispatch(new LogLogoutsuccessAction({ token: null, expiresIn: -1, user: null }));
    } else if (route.queryParams.hasOwnProperty('pid')) {
      this.router.navigate(['/provision/login'], { queryParams: { reason: 'LOGIN_AUTH_FAILURE' } });
    }
    if (state.url === '/login' && environment.APP_ENV === 'production') {
      this.router.navigate(['provision/login']);
    }

    return true;
  }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  private getParamValueQueryString(paramName) {
    const url = window.location.href;
    let paramValue;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(paramName);
    }
    return paramValue;
  }
}
